export const minWordsToPracticeSpecificBook = 6;

// If the server version is detected to be ahead of the client version, the client will be forced to
// do a full page refresh to ensure compatibility.
export const clientServerCompatibilityVersion = 2;

export const audioUploadLimitPremium = 5 * 3600; // seconds
export const audioUploadLimitPremiumPlus = 100 * 3600; // seconds

/** For purposes of calculating daily streak goal */
export const wordEquivalentOfPractice = 50;

/** Maximum length of a chat user message in number of characters */
export const maxChatMessageLength = 800;
